// AuthContext.tsx
import React, { createContext, useContext, useState, ReactNode } from 'react';

export interface UserData {
    id: number
    name: string
    job_title: string
    personal_image: string
    wall_of_fame_allowed: number
    spotlight_allowed: number
    endorsement_allowed: number
    // wof_quota: number
    // spotlight_quota: number
    // endorsement_quota: number
    created_at: string
    user_role_id: number;
    wof_approve_publish_allowed: number;
}

export interface GeneralSettings {
    id: number
    key: string
    label: string
    value: string
    created_by: any
    updated_by: number
    created_at: string
    updated_at: string
}


// Define the shape of your metadata
export interface MetaData {
    nomination_types: { value: string, label: string }[]
    recognition_for: { value: string, label: string }[]
    nomination_status: { value: string, label: string }[]
    endorsement_status: { value: string, label: string }[]
    teams: { value: string, label: string }[]
    // general_settings: GeneralSettings
}

// Define the shape of your authdata
export interface AuthData {
    token: string
    user: UserData
    meta: MetaData
    permissions: any[],
    menu: any[],
    general_settings: any[]
}

// Define the context type
interface AuthContextType {
    auth: AuthData;
    setAuth: React.Dispatch<React.SetStateAction<AuthData>>;
}

// Create the context with an initial undefined value
const AuthContext = createContext<AuthContextType | undefined>(undefined);

// Custom hook for consuming the context
export const useAuth = (): AuthContextType => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within a AuthProvider');
    }
    return context;
};

// Provider component
export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [auth, setAuth] = useState<AuthData>({ token: '', user: { id: 0, name: '', job_title: '', personal_image: '', created_at: '', wall_of_fame_allowed: 0, spotlight_allowed: 0, endorsement_allowed: 0, user_role_id: 0, wof_approve_publish_allowed: 0 }, meta: { nomination_types: [], recognition_for: [], nomination_status: [], endorsement_status: [], teams: [] }, permissions: [], menu: [], general_settings: [] });

    return (
        <AuthContext.Provider value={{ auth, setAuth }}>
            {children}
        </AuthContext.Provider>
    );
};